/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_CartonsInputs */

const en_inbound_field_cartons = /** @type {(inputs: Inbound_Field_CartonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartons`)
};

/**
* | output |
* | --- |
* | "Cartons" |
*
* @param {Inbound_Field_CartonsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_cartons = /** @type {((inputs?: Inbound_Field_CartonsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_CartonsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_cartons(inputs)
});